import React from "react";
import rill from "rill";
import set from "@rill/set";
import MetricsNav from "../../../parts/metrics-nav";

import getDailyStats from "../../athlete-portal/calendar/daily-stats.controller";
import defaultQueryDate from "../../athlete-portal/metrics/default-query-date.controller";
import Metrics from "./metrics";
import Custom from "./custom";
import OverUnderBaseline from "./over-under-baseline";
import VolumeIntensity from "./volume-intensity";
import NumberOfLifts from "./number-of-lifts";
import CoreAccessoryVolumeSplit from "./core-accessory-volume-split";
import BaselineVolumeRelativeIntensity from "./baseline-volume-relative-intensity";
import RecordTable from "./record-table";
import RawEquippedVolumeSplit from "./raw-equipped-volume-split";
import VolumeSplitCoreLift from "./volume-split-core-lift";
import CompetitionHistory from "./competition-history";
import RepMaxEstimator from "./rep-max-estimator";
import RpeTable from "./rpe-table";
import Bodyweight from "../../athlete-portal/calendar/bodyweight/bodyweight.controller";
import RestingHeartRate from "../../athlete-portal/calendar/resting-heart-rate/resting-heart-rate.controller";
import SessionRpe from "../../athlete-portal/calendar/session-rpe-controller";
import ReadinessRate from "../../athlete-portal/calendar/readiness-rate-controller";
import ProgressPhotos from "../../athlete-portal/calendar/progress-photos-controller";
import BodyMeasurements from "../../athlete-portal/calendar/body-measurements-controller";
import ExerciseHistory from "../../athlete-portal/calendar/exercise-history-controller";
import VideoList from "../../athlete-portal/calendar/video-list-controller";
import StepCount from "../../athlete-portal/calendar/step-count/step-count.controller";
import SleepTime from "../../athlete-portal/calendar/sleep-time/sleep-time.controller";
import Hrv from "../../athlete-portal/calendar/hrv/hrv.controller";
import RpeReport from "../../athlete-portal/calendar/rpe-report-controller";
import PersonalRecord from "../../athlete-portal/calendar/personal-record-controller";
import BodyFatController from "../../athlete-portal/calendar/body-fat/body-fat.controller";
import BodyCompositionController from "../../athlete-portal/calendar/body-composition-controller";
import AccountabilityController from "../../athlete-portal/calendar/accountability-tracker/accountability.controller";
import MenstrualCycleController from "../../athlete-portal/calendar/menstrual-cycle/menstrual-cycle.controller";
import MealPhotosController from "../../athlete-portal/metrics/meal-photos/meal-photos-controller";

const MetricsController = (app) => {
  app.at(
    "/metrics/*",
    rill()
      .use(set("heading", [<MetricsNav />]))
      .setup(defaultQueryDate)
      .setup(getDailyStats)
      .setup(Metrics)
      .setup(Custom)
      .setup(OverUnderBaseline)
      .setup(VolumeIntensity)
      .setup(NumberOfLifts)
      .setup(CoreAccessoryVolumeSplit)
      .setup(BaselineVolumeRelativeIntensity)
      .setup(RecordTable)
      .setup(RawEquippedVolumeSplit)
      .setup(VolumeSplitCoreLift)
      .setup(CompetitionHistory)
      .setup(RepMaxEstimator)
      .setup(RpeTable)
      .setup(Bodyweight)
      .setup(RestingHeartRate)
      .setup(SessionRpe)
      .setup(ReadinessRate)
      .setup(ProgressPhotos)
      .setup(BodyMeasurements)
      .setup(ExerciseHistory)
      .setup(VideoList)
      .setup(StepCount)
      .setup(SleepTime)
      .setup(Hrv)
      .setup(RpeReport)
      .setup(PersonalRecord)
      .setup(BodyFatController)
      .setup(BodyCompositionController)
      .setup(AccountabilityController)
      .setup(MenstrualCycleController)
      .setup(MealPhotosController)
  );
};

export default MetricsController;
